<template lang="html">
    <div class="field">
        <div class="field__label">{{label}}</div>
        <div class="field__input-wrapper" v-if="type === 'password'">
            <input :type="displayPassword ? 'text' : type" class="field__input" :class="{
                    'field__input--password': type === 'password'
                }" :placeholder="placeholder" :disabled="disabled" v-on:blur="$emit('blur')"
                v-on:focus="$emit('focus')" @keyup="$emit('keyup', $event)"
                @input="$emit('input', $event.target.value)" />
                
            <router-link :to="{ path: '/forgot/password' }" tag="span" v-if="currentRoute=='/login'">
                <a href="#">Ai uitat parola?</a>
            </router-link>
            <i class="field__input-icon far" :class="{
                'fa-eye': !displayPassword,
                'fa-eye-slash': displayPassword
            }" @click="displayPassword = !(displayPassword)" />
        </div>

        <template v-else>
            <input 
                :type="type" 
                :value="value" 
                class="field__input" 
                :class="{
                    'field__input--icon-space': image !== '',
                    'field__input--disabled': disabled
                }" 
                :placeholder="placeholder" 
                :disabled="disabled"
                v-on:blur="$emit('blur')"
                v-on:focus="$emit('focus')" 
                @keyup="$emit('keyup', $event)"
                @input="$emit('input', $event.target.value)" 
            />
            <img v-if="image !== ''" :src="getImage(image)" class="field__svg-icon" />
        </template>
        <div class="field__error">{{error}}</div>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            placeholder: {
                type: String,
                default: ''
            },
            value: {
                type: [String, Number],
                default: ''
            },
            error: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            image: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                displayPassword: false,
            };
        },
        methods: {
            getImage(image) {
                return require('@/assets/images/icons/' + image);
            }
        },
        computed: {
            forgotPasswordIcon() {
                return this.$router.currentRoute.name === "login";
            },
            currentRoute () {
                return this.$route.path;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .field {
        width: 100%;
        // margin: 15px auto auto auto;
        position: relative;

        &__label {
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 5px;
            color: $color-auth-text-main;
        }

        &__input-wrapper {
            position: relative;
            height: 45px;

            a {
                position: absolute;
                right: 0px;
                top: -22px;
                text-decoration: none;
                font-size: 12px;
                color: $color-primary;
            }
        }

        &__input-icon {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translate(0%, -50%);
            font-size: 24px;
            color: $color-auth-text-main;
        }

        &__svg-icon {
            position: absolute;
            left: 10px;
            margin-top: 10px;
            height: 25px;
            width: 25px;
        }

        &__input {
            box-sizing: border-box;
            width: 100%;
            height: 45px;
            padding-left: 10px;
            border: 1px solid #DDDFE1;
            outline: none;
            color: #464A53;

            &--password {
                position: absolute;
                left: 0px;
                -webkit-appearance: none;
            }

            &--icon-space {
                padding-left: 40px;
            }
            
            &--disabled {
                cursor: not-allowed;
            }
        }


        &__input::placeholder {
            color: $color-placeholder;
        }

        &__input:focus {
            border: 1px solid $color-secondary;
        }

        &__error {
            color: $color-danger;
            font-size: 12px;
            font-family: "Roboto";
            margin-top: 10px;

        }

        &__text {
            display: flex;
            flex-direction: row;
            font-family: "Roboto";
            font-weight: 400;
            font-size: 12px;
            color: $color-primary;
            max-width: 450px;
            margin: 30px auto auto auto;
        }
    }

    .birthday-select {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &__input {
            width: 30%;
            height: 45px;
            padding-left: 10px;
            border: 1px solid #DDDFE1;
            outline: none;
            color: #464A53;
        }

    }
</style>